import { IconButton } from "web/components"

import useSettingsModal from "./useSettingsModal"

export default function TableSettingsButton({
  viewType,
  viewId,
  enableFieldSelection = true,
}) {
  const showSettingsModal = useSettingsModal({
    viewType,
    viewId,
    enableFieldSelection,
  })

  return (
    <IconButton
      testId="button-field-selector"
      name="cog"
      outline
      onClick={showSettingsModal}
    />
  )
}
